"use client";

import Image, { type ImageProps } from "next/image";
import { useEffect, useState } from "react";

const PLACEHOLDER = "/assets/imagePlaceholder.png";

const PRESIGNED_QUERY_RE =
  /[?&](AWSAccessKeyId|Signature|X-Amz-Algorithm|X-Amz-Signature)=/;

export function isPresignedUrl(src: ImageProps["src"]): boolean {
  return typeof src === "string" && PRESIGNED_QUERY_RE.test(src);
}

export function RemoteImage({
  src,
  unoptimized,
  onError,
  ...props
}: ImageProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const resolvedSrc = failed || !src ? PLACEHOLDER : src;

  return (
    <Image
      {...props}
      src={resolvedSrc}
      unoptimized={unoptimized ?? isPresignedUrl(src)}
      onError={(event) => {
        setFailed(true);
        onError?.(event);
      }}
    />
  );
}
